<div *ngIf="radioButtonsDisplay">
  <span
    *ngIf="!isRadioButtonSelected"
    class="icon-radio-button mdi mdi-radiobox-blank"
  ></span>
  <span
    *ngIf="isRadioButtonSelected"
    class="icon-radio-button text-primary mdi mdi-record-circle"
  ></span>
</div>
<ng-template #tipContent let-contents="contents">{{ contents }}</ng-template>
<div
  class="card-detail"
  (dblclick)="contentDoubleClicked.emit()"
  (click)="toggleExpanded()"
>
  <div class="session-card-header">
    <button
      nf-icon-button="primary"
      [ngbTooltip]="pinMessageTooltip"
      class="btn-bare pin"
      container="body"
      [icon]="_session?.isPinned ? 'pin' : 'pin-outline'"
      (click)="pinSession()"
      [disabled]="_session?.isPinned || isMaxedPinnedSessionsReached"
    >
      Pin
    </button>

    <ng-template #accountsTip>{{ acctsTooltip }}</ng-template>
    <h5 class="mb-0" [ngbTooltip]="accountsTip" class="disable-selection">
      {{ cardTitle }}
    </h5>
    <button
      nf-icon-button="primary"
      [ngbTooltip]="tipContent"
      class="btn-bare copy-link"
      container="body"
      [icon]="copyLinkIcon"
      (click)="copySessionLink(copyToolTip)"
      #copyToolTip="ngbTooltip"
    >
      Copy Link
    </button>
    <div class="badge badge-light ml-1" *ngIf="usersInSession.length > 0">
      <span
        class="mdi"
        *ngIf="usersInSession.length > 1"
        [ngClass]="{
          'mdi-account-multiple': usersInSession.length === 2,
          'mdi-account-group': usersInSession.length >= 3
        }"
        [ngbTooltip]="usersInSession.join(', ')"
      ></span>
    </div>
    <ng-template #tipContent
      >{{ _session?.sumOfCommands ?? 0 }} Unsubmitted Commands</ng-template
    >
    <div
      class="badge badge-light ml-1 command-counter"
      [ngbTooltip]="tipContent"
      container="body"
      *ngIf="!hideCommandCount"
    >
      {{ _session?.sumOfCommands ?? 0 }}
    </div>
  </div>
  <div *ngIf="isActive || isExpanded" class="expanded-detail">
    <p class="small mb-0">Recon Date: {{ reconDate }}</p>
    <p class="small mb-0">Data Since: {{ windowDate }}</p>
    <p *ngIf="basisName" class="small mb-0">Basis Name: {{ basisName }}</p>
    <p
      class="small mb-0 created-detail"
      [ngbTooltip]="dateTimeFormatter(this.createdDate)"
    >
      Created {{ createdDate | ago: true }}
    </p>
  </div>
</div>
<ng-content></ng-content>
